/* src/routes/privacy-policy.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { preloader } from "./preload.js";
import { News } from "../../_modules/news/index.js";
import { Car } from "../../_modules/car/index.js";
import Page from "../../_components/slot/Page.js";
import Wrap from "../../_components/slot/Wrap.js";
import Section from "../../_components/slot/Section.js";
import Center from "../../_components/slot/Center.js";
import Button from "../../_components/button/Simple.js";
import List from "../../_components/list/List.js";
import Item from "../../_components/list/Item.js";
import Title from "../../_components/block/Title.js";
import Content from "../../_components/slot/Content.js";
import NewsLink from "../../_components/news/Link.js";
import CarLink from "../../_components/car/LargeLink.js";
import CTA from "../../_components/block/CTA.js";
import CTContact from "../../_components/block/CTContact.js";
import Head from "../../_components/meta/Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

// (25:343) <Content>
function create_default_slot_12(ctx) {
	let h20;
	let t0;
	let p0;
	let t1;
	let h21;
	let t2;
	let p1;
	let t3;
	let h22;
	let t4;
	let p2;
	let t5;
	let br0;
	let t6;
	let h23;
	let t7;
	let p3;
	let t8;
	let ul;
	let li0;
	let t9;
	let li1;
	let t10;
	let li2;
	let t11;
	let h24;
	let t12;
	let p4;
	let t13;
	let h25;
	let t14;
	let p5;
	let t15;
	let h26;
	let t16;
	let p6;
	let t17;
	let h27;
	let t18;
	let p7;
	let t19;
	let h28;
	let t20;
	let p8;
	let t21;
	let p9;
	let t22;
	let h29;
	let t23;
	let p10;
	let t24;
	let p11;
	let t25;
	let p12;
	let t26;
	let br1;
	let t27;

	return {
		c() {
			h20 = element("h2");
			t0 = text("個人情報保護方針");
			p0 = element("p");
			t1 = text("当社は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。");
			h21 = element("h2");
			t2 = text("個人情報の管理");
			p1 = element("p");
			t3 = text("当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。");
			h22 = element("h2");
			t4 = text("個人情報の利用目的");
			p2 = element("p");
			t5 = text("本ウェブサイトでは、お客様からのお問い合わせ時に、お名前、e-mailアドレス、電話番号等の個人情報をご登録いただく場合がございますが、これらの個人情報はご提供いただく際の目的以外では利用いたしません。");
			br0 = element("br");
			t6 = text("お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。");
			h23 = element("h2");
			t7 = text("個人情報の第三者への開示・提供の禁止");
			p3 = element("p");
			t8 = text("当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。");
			ul = element("ul");
			li0 = element("li");
			t9 = text("お客さまの同意がある場合");
			li1 = element("li");
			t10 = text("お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合");
			li2 = element("li");
			t11 = text("法令に基づき開示することが必要である場合");
			h24 = element("h2");
			t12 = text("個人情報の安全対策");
			p4 = element("p");
			t13 = text("当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。");
			h25 = element("h2");
			t14 = text("ご本人の照会");
			p5 = element("p");
			t15 = text("お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。");
			h26 = element("h2");
			t16 = text("法令、規範の遵守と見直し");
			p6 = element("p");
			t17 = text("当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。");
			h27 = element("h2");
			t18 = text("Cookieについて");
			p7 = element("p");
			t19 = text("当社は、当社のウェブサイトをより一層便利にご利用いただけるよう、サイトの中にCookies（クッキー）を使用する場合がありますが、Cookiesによって個人を特定できる情報を得ることはありません。");
			h28 = element("h2");
			t20 = text("アクセス解析ツールについて");
			p8 = element("p");
			t21 = text("当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。");
			p9 = element("p");
			t22 = text("このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。この規約に関して、詳しくはここをクリックしてください。");
			h29 = element("h2");
			t23 = text("お問い合わせ");
			p10 = element("p");
			t24 = text("当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。");
			p11 = element("p");
			t25 = text("TEL：027-212-8133");
			p12 = element("p");
			t26 = text("株式会社アルベロ");
			br1 = element("br");
			t27 = text("群馬県前橋市上長磯町13-1");
		},
		l(nodes) {
			h20 = claim_element(nodes, "H2", {});
			var h20_nodes = children(h20);
			t0 = claim_text(h20_nodes, "個人情報保護方針");
			h20_nodes.forEach(detach);
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t1 = claim_text(p0_nodes, "当社は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。");
			p0_nodes.forEach(detach);
			h21 = claim_element(nodes, "H2", {});
			var h21_nodes = children(h21);
			t2 = claim_text(h21_nodes, "個人情報の管理");
			h21_nodes.forEach(detach);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			t3 = claim_text(p1_nodes, "当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。");
			p1_nodes.forEach(detach);
			h22 = claim_element(nodes, "H2", {});
			var h22_nodes = children(h22);
			t4 = claim_text(h22_nodes, "個人情報の利用目的");
			h22_nodes.forEach(detach);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			t5 = claim_text(p2_nodes, "本ウェブサイトでは、お客様からのお問い合わせ時に、お名前、e-mailアドレス、電話番号等の個人情報をご登録いただく場合がございますが、これらの個人情報はご提供いただく際の目的以外では利用いたしません。");
			br0 = claim_element(p2_nodes, "BR", {});
			t6 = claim_text(p2_nodes, "お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。");
			p2_nodes.forEach(detach);
			h23 = claim_element(nodes, "H2", {});
			var h23_nodes = children(h23);
			t7 = claim_text(h23_nodes, "個人情報の第三者への開示・提供の禁止");
			h23_nodes.forEach(detach);
			p3 = claim_element(nodes, "P", {});
			var p3_nodes = children(p3);
			t8 = claim_text(p3_nodes, "当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。");
			p3_nodes.forEach(detach);
			ul = claim_element(nodes, "UL", {});
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", {});
			var li0_nodes = children(li0);
			t9 = claim_text(li0_nodes, "お客さまの同意がある場合");
			li0_nodes.forEach(detach);
			li1 = claim_element(ul_nodes, "LI", {});
			var li1_nodes = children(li1);
			t10 = claim_text(li1_nodes, "お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合");
			li1_nodes.forEach(detach);
			li2 = claim_element(ul_nodes, "LI", {});
			var li2_nodes = children(li2);
			t11 = claim_text(li2_nodes, "法令に基づき開示することが必要である場合");
			li2_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			h24 = claim_element(nodes, "H2", {});
			var h24_nodes = children(h24);
			t12 = claim_text(h24_nodes, "個人情報の安全対策");
			h24_nodes.forEach(detach);
			p4 = claim_element(nodes, "P", {});
			var p4_nodes = children(p4);
			t13 = claim_text(p4_nodes, "当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。");
			p4_nodes.forEach(detach);
			h25 = claim_element(nodes, "H2", {});
			var h25_nodes = children(h25);
			t14 = claim_text(h25_nodes, "ご本人の照会");
			h25_nodes.forEach(detach);
			p5 = claim_element(nodes, "P", {});
			var p5_nodes = children(p5);
			t15 = claim_text(p5_nodes, "お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。");
			p5_nodes.forEach(detach);
			h26 = claim_element(nodes, "H2", {});
			var h26_nodes = children(h26);
			t16 = claim_text(h26_nodes, "法令、規範の遵守と見直し");
			h26_nodes.forEach(detach);
			p6 = claim_element(nodes, "P", {});
			var p6_nodes = children(p6);
			t17 = claim_text(p6_nodes, "当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。");
			p6_nodes.forEach(detach);
			h27 = claim_element(nodes, "H2", {});
			var h27_nodes = children(h27);
			t18 = claim_text(h27_nodes, "Cookieについて");
			h27_nodes.forEach(detach);
			p7 = claim_element(nodes, "P", {});
			var p7_nodes = children(p7);
			t19 = claim_text(p7_nodes, "当社は、当社のウェブサイトをより一層便利にご利用いただけるよう、サイトの中にCookies（クッキー）を使用する場合がありますが、Cookiesによって個人を特定できる情報を得ることはありません。");
			p7_nodes.forEach(detach);
			h28 = claim_element(nodes, "H2", {});
			var h28_nodes = children(h28);
			t20 = claim_text(h28_nodes, "アクセス解析ツールについて");
			h28_nodes.forEach(detach);
			p8 = claim_element(nodes, "P", {});
			var p8_nodes = children(p8);
			t21 = claim_text(p8_nodes, "当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。");
			p8_nodes.forEach(detach);
			p9 = claim_element(nodes, "P", {});
			var p9_nodes = children(p9);
			t22 = claim_text(p9_nodes, "このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。この規約に関して、詳しくはここをクリックしてください。");
			p9_nodes.forEach(detach);
			h29 = claim_element(nodes, "H2", {});
			var h29_nodes = children(h29);
			t23 = claim_text(h29_nodes, "お問い合わせ");
			h29_nodes.forEach(detach);
			p10 = claim_element(nodes, "P", {});
			var p10_nodes = children(p10);
			t24 = claim_text(p10_nodes, "当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。");
			p10_nodes.forEach(detach);
			p11 = claim_element(nodes, "P", {});
			var p11_nodes = children(p11);
			t25 = claim_text(p11_nodes, "TEL：027-212-8133");
			p11_nodes.forEach(detach);
			p12 = claim_element(nodes, "P", {});
			var p12_nodes = children(p12);
			t26 = claim_text(p12_nodes, "株式会社アルベロ");
			br1 = claim_element(p12_nodes, "BR", {});
			t27 = claim_text(p12_nodes, "群馬県前橋市上長磯町13-1");
			p12_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, h20, anchor);
			append(h20, t0);
			insert(target, p0, anchor);
			append(p0, t1);
			insert(target, h21, anchor);
			append(h21, t2);
			insert(target, p1, anchor);
			append(p1, t3);
			insert(target, h22, anchor);
			append(h22, t4);
			insert(target, p2, anchor);
			append(p2, t5);
			append(p2, br0);
			append(p2, t6);
			insert(target, h23, anchor);
			append(h23, t7);
			insert(target, p3, anchor);
			append(p3, t8);
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, t9);
			append(ul, li1);
			append(li1, t10);
			append(ul, li2);
			append(li2, t11);
			insert(target, h24, anchor);
			append(h24, t12);
			insert(target, p4, anchor);
			append(p4, t13);
			insert(target, h25, anchor);
			append(h25, t14);
			insert(target, p5, anchor);
			append(p5, t15);
			insert(target, h26, anchor);
			append(h26, t16);
			insert(target, p6, anchor);
			append(p6, t17);
			insert(target, h27, anchor);
			append(h27, t18);
			insert(target, p7, anchor);
			append(p7, t19);
			insert(target, h28, anchor);
			append(h28, t20);
			insert(target, p8, anchor);
			append(p8, t21);
			insert(target, p9, anchor);
			append(p9, t22);
			insert(target, h29, anchor);
			append(h29, t23);
			insert(target, p10, anchor);
			append(p10, t24);
			insert(target, p11, anchor);
			append(p11, t25);
			insert(target, p12, anchor);
			append(p12, t26);
			append(p12, br1);
			append(p12, t27);
		},
		d(detaching) {
			if (detaching) detach(h20);
			if (detaching) detach(p0);
			if (detaching) detach(h21);
			if (detaching) detach(p1);
			if (detaching) detach(h22);
			if (detaching) detach(p2);
			if (detaching) detach(h23);
			if (detaching) detach(p3);
			if (detaching) detach(ul);
			if (detaching) detach(h24);
			if (detaching) detach(p4);
			if (detaching) detach(h25);
			if (detaching) detach(p5);
			if (detaching) detach(h26);
			if (detaching) detach(p6);
			if (detaching) detach(h27);
			if (detaching) detach(p7);
			if (detaching) detach(h28);
			if (detaching) detach(p8);
			if (detaching) detach(p9);
			if (detaching) detach(h29);
			if (detaching) detach(p10);
			if (detaching) detach(p11);
			if (detaching) detach(p12);
		}
	};
}

// (25:337) <Wrap>
function create_default_slot_11(ctx) {
	let content;
	let current;

	content = new Content({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(content.$$.fragment);
		},
		l(nodes) {
			claim_component(content.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(content, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const content_changes = {};

			if (dirty & /*$$scope*/ 128) {
				content_changes.$$scope = { dirty, ctx };
			}

			content.$set(content_changes);
		},
		i(local) {
			if (current) return;
			transition_in(content.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(content.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(content, detaching);
		}
	};
}

// (25:328) <Section>
function create_default_slot_10(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 128) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (25:1784) <Section background="/images/back_contact.jpg" kind="gapless">
function create_default_slot_9(ctx) {
	let ctcontact;
	let current;

	ctcontact = new CTContact({
			props: { color: "red", position: "right" }
		});

	return {
		c() {
			create_component(ctcontact.$$.fragment);
		},
		l(nodes) {
			claim_component(ctcontact.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(ctcontact, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(ctcontact.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ctcontact.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ctcontact, detaching);
		}
	};
}

// (25:2040) <Item columns="4">
function create_default_slot_8(ctx) {
	let newslink;
	let current;

	newslink = new NewsLink({
			props: { newsItem: /*item*/ ctx[2], reverse: true }
		});

	return {
		c() {
			create_component(newslink.$$.fragment);
		},
		l(nodes) {
			claim_component(newslink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(newslink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const newslink_changes = {};
			if (dirty & /*news*/ 1) newslink_changes.newsItem = /*item*/ ctx[2];
			newslink.$set(newslink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(newslink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(newslink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(newslink, detaching);
		}
	};
}

// (25:2020) {#each news as item}
function create_each_block_1(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "4",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (25:2014) <List>
function create_default_slot_7(ctx) {
	let each_1_anchor;
	let current;
	let each_value_1 = /*news*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 1) {
				each_value_1 = /*news*/ ctx[0];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (25:2008) <Wrap>
function create_default_slot_6(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (25:1908) <Section name="お知らせ" en="NEWS" more="{['/news', 'すべてのお知らせを見る']}" background="/images/back_news.jpg">
function create_default_slot_5(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (25:2276) <Item columns="2">
function create_default_slot_4(ctx) {
	let carlink;
	let current;
	carlink = new CarLink({ props: { car: /*item*/ ctx[2] } });

	return {
		c() {
			create_component(carlink.$$.fragment);
		},
		l(nodes) {
			claim_component(carlink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(carlink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const carlink_changes = {};
			if (dirty & /*cars*/ 2) carlink_changes.car = /*item*/ ctx[2];
			carlink.$set(carlink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(carlink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carlink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carlink, detaching);
		}
	};
}

// (25:2256) {#each cars as item}
function create_each_block(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (25:2250) <List>
function create_default_slot_3(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*cars*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*cars*/ 2) {
				each_value = /*cars*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (25:2244) <Wrap>
function create_default_slot_2(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (25:2143) <Section name="車両一覧" en="STOCK" more="{['/stock', 'すべての車両を見る']}" background="/images/back_stock.jpg">
function create_default_slot_1(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (25:246) <Page>
function create_default_slot(ctx) {
	let title;
	let section0;
	let section1;
	let section2;
	let section3;
	let current;

	title = new Title({
			props: {
				title: "個人情報保護方針",
				en: "",
				background: "/images/back_privacy.jpg"
			}
		});

	section0 = new Section({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				background: "/images/back_contact.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				name: "お知らせ",
				en: "NEWS",
				more: ["/news", "すべてのお知らせを見る"],
				background: "/images/back_news.jpg",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				name: "車両一覧",
				en: "STOCK",
				more: ["/stock", "すべての車両を見る"],
				background: "/images/back_stock.jpg",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(title.$$.fragment);
			create_component(section0.$$.fragment);
			create_component(section1.$$.fragment);
			create_component(section2.$$.fragment);
			create_component(section3.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
			claim_component(section0.$$.fragment, nodes);
			claim_component(section1.$$.fragment, nodes);
			claim_component(section2.$$.fragment, nodes);
			claim_component(section3.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			mount_component(section0, target, anchor);
			mount_component(section1, target, anchor);
			mount_component(section2, target, anchor);
			mount_component(section3, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
			destroy_component(section0, detaching);
			destroy_component(section1, detaching);
			destroy_component(section2, detaching);
			destroy_component(section3, detaching);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let page;
	let current;

	head = new Head({
			props: {
				title: "個人情報保護方針 | 株式会社アルベロ | 群馬県の輸入車販売店",
				path: "/privacy-policy",
				description: "株式会社アルベロの個人情報保護方針です。株式会社アルベロは、群馬県前橋市にある自動車販売店です。輸入車を中心に、高品質な車両を新車、中古車問わずどんな車両でも常時取り揃えております。自社工場も完備しているので、購入後のメンテナンスもお任せください。",
				image: "/images/keyvisual.jpg"
			}
		});

	page = new Page({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(head.$$.fragment);
			create_component(page.$$.fragment);
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			claim_component(page.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			mount_component(page, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const page_changes = {};

			if (dirty & /*$$scope, cars, news*/ 131) {
				page_changes.$$scope = { dirty, ctx };
			}

			page.$set(page_changes);
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(page.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(page.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			destroy_component(page, detaching);
		}
	};
}

const preload = preloader;

function instance($$self, $$props, $$invalidate) {
	let { news = [] } = $$props;
	let { cars = [] } = $$props;

	$$self.$$set = $$props => {
		if ("news" in $$props) $$invalidate(0, news = $$props.news);
		if ("cars" in $$props) $$invalidate(1, cars = $$props.cars);
	};

	return [news, cars];
}

class Privacy_policy extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { news: 0, cars: 1 });
	}
}

export default Privacy_policy;
export { preload };
//# sourceMappingURL=privacy-policy.js.map
